import {
  GET_PARTNERTHEME_FAILED,
  GET_PARTNERTHEME_LOADING,
  GET_PARTNERTHEME_REMOVE,
  GET_PARTNERTHEME_SUCCESS,
} from "../types";
import { addpartnerThemeEndpoint, getPartnerThemeEndpoint, updatepartnerThemeEndpoint } from "../../api/apisUrl";
import api from "../../api";
import { apiError } from "../../models";

export const partnerThemeCrudOperations = (/*token:any,*/ type: any, hostName?: string, partnerId?: string | null, formData?: any,) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      status?: any;
      error?: any;
      request?: string
    }) => void
  ) => {
    dispatch({ type: GET_PARTNERTHEME_LOADING, loading: true, request: type });

    const callackFun = async () => {
      if (type === 'post') {
        return await api.post(
          addpartnerThemeEndpoint(),
          JSON.stringify(formData),
          {
            headers: {
              "Content-type": "application/json",
              // Authorization: `Bearer ${token}`,
            },
          }
        )
      }
      else if (type === "get") {
        return await api.get(

          getPartnerThemeEndpoint(hostName, partnerId),
          {
            headers: {
              "Content-type": "application/json",
              // Authorization: `Bearer ${token}`,
            },
          }
        )

      }
      else if (type === "put") {
        return await api.put(
          updatepartnerThemeEndpoint(),
          formData,
          {
            headers: {
              "Content-type": "application/json",
              // Authorization: `Bearer ${token}`,
            },
          }
        )

      }

    }



    callackFun().then((res: any) => {
      dispatch({ type: GET_PARTNERTHEME_LOADING, loading: false, request: type });
      dispatch({ type: GET_PARTNERTHEME_SUCCESS, payload: res.data, status: res.status, request: type });
    })
      .catch((err: any) => {
        apiError(GET_PARTNERTHEME_LOADING, GET_PARTNERTHEME_FAILED, err, dispatch, type);
      });

  };
};



export const RemovepartnerTheme = () => {
  return {
    type: GET_PARTNERTHEME_REMOVE
  }
}
